import { ComponentProps, ReactNode } from "react";

import { cn } from "@bentolabs/kit/utils";
import { Fragment } from "react/jsx-runtime";

export type ItemType = {
  label: ReactNode;
  value: ReactNode;
};

const Item = ({ label, value }: ItemType) => {
  return (
    <Fragment>
      <div className="text-nobel place-self-start text-sm font-normal">
        {label}
      </div>
      <div className="place-self-end text-sm text-white">{value}</div>
    </Fragment>
  );
};

type Props = {
  items?: ItemType[];
};

export const Table = ({
  items,
  className,
  children,
  ...props
}: Props & ComponentProps<"div">) => {
  return (
    <div
      className={cn("grid grid-cols-2 gap-4 text-xs leading-6", className)}
      {...props}
    >
      {children ??
        items?.map((item, index) => {
          return <Item key={index} label={item.label} value={item.value} />;
        })}
    </div>
  );
};

Table.Item = Item;
